import { render, staticRenderFns } from "./PayeeMatchConfigDialog.vue?vue&type=template&id=0f48b683&scoped=true&"
import script from "./PayeeMatchConfigDialog.vue?vue&type=script&lang=js&"
export * from "./PayeeMatchConfigDialog.vue?vue&type=script&lang=js&"
import style0 from "./PayeeMatchConfigDialog.vue?vue&type=style&index=0&id=0f48b683&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f48b683",
  null
  
)

export default component.exports